// extracted by mini-css-extract-plugin
module.exports = {"root":"AirLiveCard_root__3GTQB","imgBgStyle":"AirLiveCard_imgBgStyle__2XUj-","data":"AirLiveCard_data__WMM-g","title":"AirLiveCard_title__106kN","type":"AirLiveCard_type__1xxhQ"};